/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InsurerDto } from '../../models/insurer-dto';

export interface InsurersElixirLiveGet$Params {
}

export function insurersElixirLiveGet(http: HttpClient, rootUrl: string, params?: InsurersElixirLiveGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<Array<InsurerDto>>> {
  const rb = new RequestBuilder(rootUrl, insurersElixirLiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<Array<InsurerDto>>;
    })
  );
}

insurersElixirLiveGet.PATH = '/Insurers/ElixirLive';
